import { useCallback } from 'react'

/**
 * Bridges selection to bulk action handlers using provided resolvers.
 * Decoupled from data sources (react-query etc).
 */
export default function useBulkSelectionActions({
  getAllItems = () => [],
  getSelectedIds = () => new Set(),
  handleBulkAction,         // (action, selectedItemObjects) => Promise<any>
  handleBulkModalAction,    // (actionData, selectedItemObjects) => Promise<any>
  clear                     // () => void
} = {}) {
  const onListAction = useCallback(async (action) => {
    const selectedIds = getSelectedIds() || new Set()
    if (!selectedIds || selectedIds.size === 0) return

    const allItems = getAllItems() || []
    const selectedItemObjects = allItems.filter(item => selectedIds.has(item.id))

    const result = await Promise.resolve(handleBulkAction?.(action, selectedItemObjects))

    // Only clear if action completed immediately (no modal shown)
    if (result !== undefined && !action?.modalConfig) {
      if (typeof clear === 'function') clear()
    }
  }, [getAllItems, getSelectedIds, handleBulkAction, clear])

  const onBulkModalCallback = useCallback(async (actionData) => {
    const selectedIds = getSelectedIds() || new Set()
    if (!selectedIds || selectedIds.size === 0) return

    const allItems = getAllItems() || []
    const selectedItemObjects = allItems.filter(item => selectedIds.has(item.id))

    await Promise.resolve(handleBulkModalAction?.(actionData, selectedItemObjects))

    // Clear after successful modal action
    if (typeof clear === 'function') clear()
  }, [getAllItems, getSelectedIds, handleBulkModalAction, clear])

  return { onListAction, onBulkModalCallback }
}